import { resources, i18n } from '@askable/i18n';
import { initI18nZodMap, isLocale } from '@askableorg/i18n';
import { z } from 'zod';

import { Locale } from '@/generated/graphql';

const initialLang =
  typeof window !== 'undefined'
    ? (document.cookie
        .split('; ')
        .find(row => row.startsWith('lang='))
        ?.split('=')[1] ??
      window.localStorage.getItem('lang') ??
      navigator.language ??
      Locale.En)
    : Locale.En;

export const initialLocale = (isLocale(initialLang) ? initialLang.replace('-', '_') : Locale.En) as Locale;

i18n.init({
  lng: initialLang,
  ns: ['sessions', 'common', 'zod', 'components'],
  resources,
});

z.setErrorMap(initI18nZodMap(i18n));

export { z };
export default i18n;
